import {useContext, useEffect, useState} from "react";
import {Box, Stack, Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {useNavigate} from "react-router-dom";
import {
  CONTEXT_ACTION_TYPE,
  CustomWorldListPayload,
  DataStoreContext,
  WORLD_LIST_STEPS,
  WorldListPayload
} from "../../contexts/OperatingEnvironmentContext";
import {FetchMessage} from "../../../../hooks/useFetchAllQuery";
import {CustomWorldListItem} from "../lists/CustomWorldListItem";
import Pjdb1Button from "../../../../components/inputs/Pjdb1Button";
import {useCustomWorldByBaseWorld} from "../../hooks/useCustomWorld";
import {OPERATING_ENVIRONMENT_URLS} from "../../../../constants/constants";
import Pjdb1TextField from "../../../../components/inputs/Pjdb1TextField";

export default function CustomWorldListStep() {
  const navigate = useNavigate();
  const {state, dispatch} = useContext(DataStoreContext);
  const [timer, setTimer] = useState<NodeJS.Timeout | null>();
  const {fetchAll} = useCustomWorldByBaseWorld({
    baseWorldIds: [state.worldList.selectedBaseWorld?.attr["world-id"] ?? ''],
    searchText: state.worldList.customWorldSearchText,
    onChange: (newData, newStatus) => {
      dispatch({
        type: CONTEXT_ACTION_TYPE.CUSTOM_WORLD_LIST,
        payload: {customWorlds: newData, searchStatus: newStatus} satisfies CustomWorldListPayload
      });
    },
  });

  useEffect(() => {
    if (timer) {
      clearTimeout(timer);
    }

    const t = setTimeout(() => {
      fetchAll().catch(console.error);
    }, 500);
    setTimer(t);

    return () => {
      if (t) {
        clearTimeout(t);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.worldList.customWorldSearchText]);

  const customWorlds = state.customWorldList.customWorlds.map(item => Object.values(item)).flat();

  return (
    <>
      <Stack gap={1}>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Typography variant="h6" component='h2'>
            ベースワールド名：{state.worldList.selectedBaseWorld?.attr['name-jp']}
          </Typography>
          <Pjdb1Button
            label='検索結果に戻る'
            variant='text'
            color='inherit'
            onClick={() => {
              dispatch({
                type: CONTEXT_ACTION_TYPE.WORLD_LIST,
                payload: {
                  step: WORLD_LIST_STEPS.BASE_WORLD,
                } satisfies WorldListPayload
              });
            }}
          />
        </Box>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Typography variant="body2" sx={{fontWeight: "bold"}}>
            カスタムワールドを選択してください。
          </Typography>

          <Box component="span">
            {customWorlds.length > 0 ? `${customWorlds.length.toLocaleString()}件` : ""}
          </Box>
        </Box>
        <Pjdb1TextField
          label='カスタムワールド名などを入力'
          required={false}
          sx={{bgcolor: 'white', width: {xs: '100%', sm: '50%'}}}
          onChange={(e) => {
            dispatch({
              type: CONTEXT_ACTION_TYPE.WORLD_LIST,
              payload: {
                ...state.worldList,
                customWorldSearchText: e.target.value,
              } satisfies WorldListPayload
            });
          }}
          name="customWorldSearchText"
          value={state.worldList.customWorldSearchText}
        />
      </Stack>

      {customWorlds.length > 0 && (
        <Grid container alignItems="stretch" spacing={2} sx={{mt: 2}}>
          {customWorlds.map(item => (
            <Box key={item.attr['world-id']} display='flex' gap={4} onClick={() => {
              navigate(`${OPERATING_ENVIRONMENT_URLS.WORLD_DETAIL.URL}/${item.attr['world-id']}`);
            }}>
              <CustomWorldListItem item={item}/>
            </Box>
          ))}
        </Grid>
      )}

      <FetchMessage
        data={state.customWorldList.customWorlds}
        status={state.customWorldList.searchStatus}
        isEmpty={
          (value) => value.length === 0
            || value.every(item => Object.values(item).length === 0)
        }
      />
    </>
  );
}
